



























import { Component, Watch } from 'vue-property-decorator'
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import ThirdPartyAccount from '@/models/Accounts/ThirdPartyAccounts/ThirdPartyAccount';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'ThirdPartyAccountsList', components: { Alert }, metaInfo: { title: 'Accounts' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.thirdPartyAccounts.fields.accountName'), sortable: false, width: "45%" },
        { text: this.$t('pageText.thirdPartyAccounts.fields.iban'), sortable: false, width: "20%" },
        { text: this.$t('pageText.thirdPartyAccounts.fields.accountNumber'), sortable: false, width: "15%" },
        { text: this.$t('pageText.thirdPartyAccounts.fields.balance'), sortable: false, width: "30%" },
    ];
    accountsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.accountsPage = +page;
        }
    }

    async beforeMount() {
        await InstitutionAccountModule.getThirdPartyAccounts();
    }

    get labels() {
        return AuthModule.me.institution.config.labels;
    }

    get accounts() {
        return InstitutionAccountModule.thirdPartyAccounts;
    }

    get totalAccountsPages() {
        return InstitutionAccountModule.totalThirdPartyAccountsPages;
    }

    get loading() {
        return InstitutionAccountModule.loadingThirdPartyAccounts;
    }

    get pageSize() {
        return InstitutionAccountModule.pageSize;
    }

    @Watch('accountsPage')
    async onAccountsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.accountsPage}` } });
    }

    async navigateToThirdPartyAccount(account: ThirdPartyAccount) {
        this.$router.push({ name: PageNames.ThirdPartyAccount, params: { id: account.id }, query: { tab: "0" } });
    }

}
